import { render } from "./AlpacaImportView.vue?vue&type=template&id=02b4f11d"
import script from "./AlpacaImportView.vue?vue&type=script&lang=js"
export * from "./AlpacaImportView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__